import React, { useEffect, useState } from "react";
import { Table, Button, Tooltip, message, Spin, Popconfirm } from "antd";
 import { DeleteOutlined } from "@ant-design/icons";
import TitleComp from "../components/Title/title";
import { useDrawer } from "../context/drawer";
import DrawerComp from "../components/Drower/Drawer";
import { useSelector } from "react-redux";
import axios from "axios";
import { HiRefresh } from "react-icons/hi";
import { MdEditDocument } from "react-icons/md";
export default function FoodItems() {
  const columns = [
    { title: "Product Id", dataIndex: "product_Id", key: "product_Id" },
    { title: "Product Name", dataIndex: "product_name", key: "product_name" },
    { title: "Description", dataIndex: "product_desc", key: "product_desc" },
    { title: "Category", dataIndex: ["category", "category_name"], key: "category_name" },
    { title: "Product Type", dataIndex: "product_type", key: "product_type" },
    { title: "Stock Status", dataIndex: "out_stock", key: "out_stock", render: (text) => (text === "0" ? "Out of Stock" : "In Stock") },
    {
      title: "Edit",
      key: "Edit",
      render: (_, record) => (
        <Tooltip title="Edit Product" placement="bottom">
          <Button type="primary" shape="circle" onClick={() => handleDrawerUpdate(record)}icon={<MdEditDocument />} size="large"/>
        </Tooltip>
      ),
    },
    {
      title: "Delete",
      key: "Delete",
      render: (_, record) => (
        <Popconfirm
        title="Are you sure you want to delete this product?"
        description="This action cannot be undone."
        okText="Yes, Delete"
        cancelText="Cancel"
        okType="danger"
        onConfirm={() => handleDelete(record.product_Id)}
      >
        <Tooltip title="Delete Product" placement="bottom">
          <Button  style={{ backgroundColor: "#FF0000", borderColor: "#FF0000", color: "#FFFFFF" }} shape="circle" icon={<DeleteOutlined />} size="large"  />
        </Tooltip>
        </Popconfirm>
      ),
    },
  ];

  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [totalData, setTotalData] = useState(0);
  
  const { drawerData, setDrawerData } = useDrawer();
  const { token } = useSelector((state) => state.auth);

  const fetchData = async (page, limit) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://1fiveglobal.com/api/product.php?action=fetchProductsWithDetails&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH&limit=10&page=${page}`
      );

      if (response.data && response.data.list) {
        setFetchList(response.data.list);
        setTotalData(response.data.total || 0);
      } else {
        throw new Error("Failed to fetch product data");
      }
    } catch (error) {
      console.error("Error fetching product data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDrawerAdd = () => {
    setDrawerData({ isOpen: true, type: "product", title: "Product Add", ID: null });
  };

  const handleDrawerUpdate = (value) => {
    setDrawerData({ isOpen: true, type: "Updateproduct", title: "Update Product", value });
  };

  const handleDelete = async (productId) => {
    console.log("productId",productId)
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");
      formData.append("action", "updateProduct");
      formData.append("product_Id", productId);
      formData.append("is_active", "0");
  
      const response = await axios.post("https://1fiveglobal.com/api/product.php", formData);
  
      // ✅ Correct condition (200–299 range means success)
      if (response.status >= 200 && response.status < 300) {
        console.log("response", response);
        message.success(response.data.status || "Product deleted successfully");
        fetchData(currentPage, pageSize);
      } else {
        message.error(response.data.message || "Failed to delete product");
      }
    } catch (error) {
      console.log("error", error);
      message.error("Failed to delete product");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <TitleComp name="Product List" handleDrawerAdd={handleDrawerAdd} totalData={totalData} type="Products" />
      <Button
          type="primary"
          loading={loading}
          icon={<HiRefresh />}
          style={{ marginBottom: "30px" }}
          onClick={() => fetchData(currentPage, pageSize, "", "")}
        >
          Refresh Data
        </Button>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={fetchList}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalData,
            showSizeChanger: true,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
          }}
          rowKey="product_Id"
        />
      </Spin>
      <DrawerComp />
    </div>
  );
}
